import { Buildings, GlobeHemisphereWest, Path, AirplaneTilt, ChartPieSlice } from '@phosphor-icons/react';
import { useI18n } from '../i18n';

export type AppTab = 'map' | 'routes' | 'fleet' | 'finance' | 'company';

const ITEMS: Array<{ id: AppTab; labelKey: string; icon: typeof GlobeHemisphereWest }> = [
  { id: 'map', labelKey: 'ui.航线地图', icon: GlobeHemisphereWest },
  { id: 'routes', labelKey: 'ui.航线总览', icon: Path },
  { id: 'fleet', labelKey: 'ui.机队采购', icon: AirplaneTilt },
  { id: 'finance', labelKey: 'ui.财务中心', icon: ChartPieSlice },
  { id: 'company', labelKey: 'ui.公司运营', icon: Buildings },
];

export function BottomNav({
  active,
  badges = {},
  onChange,
}: {
  active: AppTab;
  badges?: Partial<Record<AppTab, number>>;
  onChange: (tab: AppTab) => void;
}) {
  const { t } = useI18n();
  return (
    <nav className="bottom-nav" aria-label={t('ui.主要页面')}>
      {ITEMS.map((item) => {
        const badge = badges[item.id] ?? 0;
        const Icon = item.icon;
        const isActive = active === item.id;
        return (
          <button key={item.id} data-tutorial-tab={item.id} className={isActive ? 'active' : ''} onClick={() => onChange(item.id)}>
            <span className="nav-icon" aria-hidden="true">
              <Icon weight={isActive ? 'fill' : 'regular'} size={20} />
            </span>
            <span>{t(item.labelKey)}</span>
            {badge > 0 && <span className="nav-badge" aria-hidden="true">{badge > 99 ? '99+' : badge}</span>}
          </button>
        );
      })}
    </nav>
  );
}
